









































































































import { Component, Vue } from 'vue-property-decorator';
import { ApiService, curApiService, EntPage } from '@/services/ApiService';
import { curPref, Preferences } from '@/services/Preferences';
import Error from '@/components/Error.vue';
import Loading from '@/components/Loading.vue';
import SearchBox from '@/components/SearchBox.vue';
import PageNav from '@/components/PageNav.vue';
import EnterpriseRow from '@/components/admin/EnterpriseRow.vue';
import EnterpriseRowMobile from '@/components/admin/EnterpriseRowMobile.vue';
import CreateEnterprise from '@/components/admin/CreateEnterprise.vue';
import DeleteEnterprise from '@/components/admin/DeleteEnterprise.vue';
import EditEnterprise from '@/components/admin/EditEnterprise.vue';
import { EnrolProfile, Enterprise } from '@/types';

@Component({
  components: {
    Error,
    Loading,
    EnterpriseRow,
    EnterpriseRowMobile,
    SearchBox,
    PageNav,
    CreateEnterprise,
    DeleteEnterprise,
    EditEnterprise,
  },
})
export default class EnterpriseList extends Vue {
  
  status:'view-all'|'create'|'edit'|'delete' = 'view-all';

  selectedEnterprise:Enterprise = {} as Enterprise;

  httpBusy:boolean = false;
  error:string = '';
  pageList:EntPage[] = [];
  curPage:EntPage = {} as EntPage;
  searchTerm = curPref.retrieve('noc-enterprise-list-search-term', '');
  enrolProfileList:EnrolProfile[] = [];
  
  // services
  apiService:ApiService = curApiService;
  
  mounted() {

    if(this.$route.params.searchTerm)
      this.searchTerm = this.$route.params.searchTerm;

    this.refreshData();
  }

  async refreshData() {

    this.httpBusy = true;

    const entReq = this.apiService.getEnterprisesPaginated({searchTerm: this.searchTerm});
    const enrolReq = this.apiService.getEnrolProfiles({}); 

    let entReply, enrolReply;

    [entReply, enrolReply] = await Promise.all([entReq,enrolReq]);

    this.httpBusy = false;

    if(entReply.httpCode === 403 || enrolReply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(entReply.errorMsg)
      return this.error = `Unable to load enterprises because ${entReply.errorMsg}`;
    
    if(enrolReply.errorMsg)
      return this.error = `Unable to load enrolment profiles because ${enrolReply.errorMsg}`;

    this.pageList = entReply.pageList!;
    this.enrolProfileList = enrolReply.enrolProfileList!;

    // we set the current page
    if(this.pageList.length > 0) {

      // we call the reset on the component
      (this.$refs.pageNav as PageNav).reset();

      this.curPage = this.pageList[0];
    }
      
  }

  newSearchText(newSearchText:string) {
    curPref.store('noc-enterprise-list-search-term', newSearchText);
    this.searchTerm = newSearchText;
    this.refreshData();
  }

  changeStatus(newStatus:'view-all'|'create'|'edit'|'delete', selectedEnterprise?:Enterprise) {
    
    this.status = newStatus;

    if(newStatus === 'view-all')
      this.refreshData();

    if(selectedEnterprise)
      this.selectedEnterprise = selectedEnterprise;
  }

  get showPageNav():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showRows():boolean {
    return this.pageList.length > 0 && !this.httpBusy;
  }

  get showNoMatches():boolean {
    return !this.httpBusy && this.pageList.length === 0 && this.searchTerm !== '' && this.error === '';
  }

  get enrolProfileIdList():string[] {
    return this.enrolProfileList.map(enrolProfile => enrolProfile.enrolId);
  }

  changePage(newPageNum:number) {
    this.curPage = this.pageList[newPageNum];
  }


}
